export const CORENAME = "Hair Growth Nutraceutical"
export const CARENAME = "Hair Care"
export const SKINNAME = "Clear Skin Nutraceutical"
export const BOOSTERNAME = "Hair Wellness Booster"
export const SCALPNAME = "Scalp Support"
export const SKINCATEGORY = "Skin"
export const BOOSTERCATEGORY = "Targeted Boosters"
export const HAIRGROWTHKIT = "Hair Growth Kit"
